// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BETypeElement } from './BETypeElement';
import { BEComponent } from './BEComponent';
import { ReferCrossAssociation } from './ReferCrossAssociation';
import { BEEntity } from './BEEntity';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 引用实体 实体类
 * 引用其他组件的实体，引用后仅可用于多对多的关系，只针对本建模工具的实体有效
 */
export class BEReferenceEntity extends BETypeElement {
  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 作为目标的引用双向关联关系 */
  private _targetReferCrossAssociations: Array<ReferCrossAssociation>;

  /** 获取：作为目标的引用双向关联关系 */
  public get targetReferCrossAssociations() {
    return this._targetReferCrossAssociations;
  }

  /** 设置：作为目标的引用双向关联关系 */
  public set targetReferCrossAssociations(value: Array<ReferCrossAssociation>) {
    this._targetReferCrossAssociations = value;
  }

  /** 引用实体 的ID */
  private _entity_ID: string;

  /** 获取：引用实体 的ID */
  public get entity_ID() {
    return this._entity_ID;
  }

  /** 设置：引用实体 的ID */
  public set entity_ID(value: string) {
    this._entity_ID = value;
  }

  /** 引用实体  */
  private _entity: BEEntity;

  /** 获取：引用实体  */
  public get entity() {
    return this._entity;
  }

  /** 设置：引用实体  */
  public set entity(value: BEEntity) {
    this._entity = value;
    if (value !== null) {
      this.entity_ID = value.id;
    } else {
      this.entity_ID = '';
    }
  }

  constructor() {
    super();
    this._component_ID = '';
    this._component = null;
    this._targetReferCrossAssociations = new Array<ReferCrossAssociation>();
    this._entity_ID = '';
    this._entity = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEReferenceEntity, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
      this.entity_ID = element.entity_ID;
      if (hasReference && element.entity !== null) {
        this.entity = element.entity;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    if (json.TargetReferCrossAssociations && json.TargetReferCrossAssociations.length > 0) {
      json.TargetReferCrossAssociations.forEach((element: any) => {
        const referCrossAssociation = ReferCrossAssociation.Create(element);
        // referCrossAssociation.targetReferenceEntity = this;
        this.targetReferCrossAssociations.push(referCrossAssociation);
      });
    }
    this.entity_ID = json.Entity_ID;
    // if (json.Entity !== null) {
    //   this.entity = BEEntity.Create(json.Entity);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Component_ID = this.component_ID;
    if (this.targetReferCrossAssociations && this.targetReferCrossAssociations.length > 0) {
      json.TargetReferCrossAssociations = [];
      this.targetReferCrossAssociations.forEach((element) => {
        json.TargetReferCrossAssociations.push(element.toJson());
      });
    }
    json.Entity_ID = this.entity_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('引用', 'entity', '引用实体', EnumDataType.Reference, this.entity, true, '', 'BEEntity', 'PGRowDataTypeValue:BEEntity');
    return context;
  }

  static Create(json: any): BEReferenceEntity {
    const bEReferenceEntity = new BEReferenceEntity();
    bEReferenceEntity.Deserialize(json);
    bEReferenceEntity.json = json;
    return bEReferenceEntity;
  }
}
